/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Line_UnnamedInputs */

const vi_kiotviet_line_unnamed = /** @type {(inputs: Kiotviet_Line_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng KiotViet không tên`)
};

/**

* @param {Kiotviet_Line_UnnamedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_line_unnamed = /** @type {((inputs?: Kiotviet_Line_UnnamedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Line_UnnamedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_line_unnamed(inputs)
});